import { CertificateApi, IAMApi, Configuration } from "@certblock/api";
import axios from 'axios';
import OidcProvider from './OidcProvider';

const BASEPATH = window.ApiCertblock.apiUrl;
const APICONFIG = window.ApiConfig;

export class ApiService {

    constructor() {
        
    }

    getIAM_API(jwt) {

        const CONF = new Configuration({ apiKey: jwt, basePath: BASEPATH }); 
        const IAM_API= new IAMApi(CONF);
        
        return IAM_API;
    }

    getCRT_API(jwt) {

        const CONF = new Configuration({ apiKey: jwt, basePath: BASEPATH }); 
        const CRT_API = new CertificateApi(CONF);
        
        return CRT_API;

    }

    async callApi(endpoint = '', params = [], callMethod = 'get', data = {}, body = {}, urlCall = '', file = null) {
        
        console.log(`DEBUG [ApiService callApi] 
            (endpoint, params, callMethod, data, body, urlCall, file): 
            (${endpoint}, ${params}, ${callMethod},  ${data}, ${body}), ${urlCall} , ${file}`);

        const oidc = new OidcProvider();
        const user = oidc.getUser();
        let url = ''
        if (endpoint === 'suppliernumber' && params[0] === 'email') {
            url = `${APICONFIG.apiUrl}/suppliers?ident=${user.profile.email}`
        } else if (endpoint === 'userRoles') {
            url = `${APICONFIG.apiUrl}/authz/users/${encodeURIComponent(params[0])}/roles`
        } else if (endpoint === 'userSuppliers') {
            url = `${APICONFIG.apiUrl}/authz/users/${encodeURIComponent(params[0])}/suppliers`
        } else if (endpoint === 'assignments') {
            url = `${APICONFIG.apiUrl}/authz/assignments`
        } else if (endpoint === 'orderList') {
            url = `${APICONFIG.apiUrl}/orders${params[0] ? `?prefix=${encodeURIComponent(params[0])}` : ''}`
        } else if (endpoint === 'materials') {
            url = `${APICONFIG.apiUrl}/orders/${params[0]}/material`
        } else if (endpoint === 'documentProfiles') {
            if(params[3]) {
                url = `${APICONFIG.apiUrl}/orders/${params[0]}/deliverynotes/${encodeURIComponent(params[1])}/documents/${params[2]}?serialNumber=${encodeURIComponent(params[3])}` //TODO testing 20250121
            } else {
                url = `${APICONFIG.apiUrl}/orders/${params[0]}/deliverynotes/${encodeURIComponent(params[1])}/documents/${params[2]}` //TODO testing 20250121
            }

        } else if (endpoint === 'documentProfilesAll') {
            url = `${APICONFIG.apiUrl}/orders/${params[0]}/deliverynotes/${encodeURIComponent(params[1])}/documents/${params[2]}/documentProfiles`
        }
        else if (endpoint === 'documentProfile') {
            // /orders/{orderNumber}/deliverynotes/{deliveryNoteNumber}/documents/{orderPosition}/documentProfiles
            // url = `${APICONFIG.apiUrl}/orders/${params[0]}/deliverynotes/${params[1]}/documents/${params[2]}/documentProfiles`
            // ?serialNumber=12345            
            if (params[4]) {
                url = `${APICONFIG.apiUrl}/orders/${params[0]}/deliverynotes/${encodeURIComponent(params[1])}/documents/${params[2]}/documentProfiles/${params[3]}?serialNumber=${encodeURIComponent(params[4])}`
            } else {
            // /orders/{orderNumber}/deliverynotes/{deliveryNoteNumber}/documents/{orderPosition}/documentProfiles
             url = `${APICONFIG.apiUrl}/orders/${params[0]}/deliverynotes/${encodeURIComponent(params[1])}/documents/${params[2]}/documentProfiles/${params[3]}`;
            }
        }else if (endpoint === 'setUploadSlots') {
            // /orders/{orderNumber}/deliverynotes/{deliveryNoteNumber}/documents/{orderPosition}/upload
            url = `${APICONFIG.apiUrl}/orders/${params[0]}/deliverynotes/${encodeURIComponent(params[1])}/documents/${params[2]}/upload`;
        } else if (endpoint === 'uploadFile') {
            url = urlCall;
        } else if (endpoint === 'pollingFiles'){
            // /orders/{orderNumber}/deliverynotes/{deliveryNoteNumber}/documents/{orderPosition}/upload/{slotId}
            url = `${APICONFIG.apiUrl}/orders/${params[0]}/deliverynotes/${encodeURIComponent(params[1])}/documents/${params[2]}/upload/${params[3]}`;
        } else if (endpoint === 'profileDocsAssignment') {
            // /orders/{orderNumber}/deliverynotes/{deliveryNoteNumber}/documents/{orderPosition}/documentProfiles/{docuProfileId}
            url = `${APICONFIG.apiUrl}/orders/${params[0]}/deliverynotes/${encodeURIComponent(params[1])}/documents/${params[2]}/documentProfiles/${params[3]}`;
        } else if (endpoint === 'getDeliveryNotes') {
            // GET /orders/{orderNumber}/deliverynotes will  a list of the existing delivery notes
            url = `${APICONFIG.apiUrl}/orders/${params[0]}/deliverynotes`
        } else if (endpoint === 'getDocuments') {
            // GET  /orders/{orderNumber}/deliverynotes/{deliveryNoteNumber}/documents/{orderPosition}
            url = `${APICONFIG.apiUrl}/orders/${params[0]}/deliverynotes/${encodeURIComponent(params[1])}/documents/${params[2]}`
        } else if (endpoint === 'changeDNN') {
            // PATCH /orders/{orderNumber}/deliverynotes/{deliveryNoteNumber}/documents 
            url = `${APICONFIG.apiUrl}/orders/${params[0]}/deliverynotes/${encodeURIComponent(params[1])}/documents`
        } else if (endpoint === 'getProfileName') {
            //GET /orders/{orderNumber}/deliverynotes/{deliveryNoteNumber}/documents/{orderPosition}/documentProfiles/{docuProfileId}/name/{language} 
             url = `${APICONFIG.apiUrl}/orders/${params[0]}/deliverynotes/${encodeURIComponent(params[1])}/documents/${params[2]}/documentProfiles/${params[3]}/name/${params[4]}`
        } else if (endpoint === 'getOrderPositions') {
            //GET orders/{orderNumber}/deliverynotes/{deliveryNoteNumber}/documents/orderPositions
            url = `${APICONFIG.apiUrl}/orders/${params[0]}/deliverynotes/${encodeURIComponent(params[1])}/documents/orderPositions`
        }

        if (user === null || !user.profile.email) {
            console.warn("User not authenticated. Unable to get API data");
            return null;
        } 

        var request;
        if (endpoint !== 'uploadFile')  { 
            request = axios({
                headers: {
                    'Authorization': user.id_token
                },
                method: callMethod, 
                url: url , 
                data: data, 
                body: body,
                // params : queryParams
            }).catch((error) => {
                console.log(`DEBUG [ApiService callApi] ERROR:`);
                console.log(JSON.stringify(error));
                throw new Error (error.message);
            });
        }

        if (endpoint === 'uploadFile') {
            request = axios({
                headers: {
                     'x-amz-server-side-encryption' : 'aws:kms'
                },
                method: callMethod, 
                url: url,
                data: file,
            }).catch((error) => {
                console.log(`DEBUG [ApiService callApi] Error:`);
                console.log(JSON.stringify(error));
                throw new Error (error.message);
            });
        }   
        return request;
    }

    async getMaterials(order, callback) {
        try {
            let response = (await this.callApi('materials', [order])).data;
            console.log('getMaterials response');
            console.log(response);
            callback(response.map(p => {
                // console.log(p);
                return {
                    // orderPosition: p.EBELP.replace(/^0+(?!\.|$)/, ''),
                    orderPosition: p.EBELP,
                    orderNumber: p.EBELN,
                    materialNumber: p.EMATN,
                    materialDescription: p.TXZ01,
                    quantity: p.BSTMG,
                    LIFNR: p.LIFNR,
                    PRFZG: p.PRFZG,
                    SERNP: p.SERNP,
                    SERNP_FLAG: p.SERNP_FLAG,
                    SERIAL_ENABLED: p.SERIAL_ENABLED,
                    SSQSS: p.SSQSS,
                    TP_DPROF: p.TP_DPROF,
                    ZGTYP: p.ZGTYP,
                    ZZ_KM_IND: p.ZZ_KM_IND,
                    BSTMG: p.BSTMG
                };
            }))
        }catch (error) {
            console.log(JSON.stringify(error));
            throw new Error (error.message);
        }
    }

    async getDeliveryNotes(orderNumer, callback) {
        // @TODO MARWAL test that call as it was returning the error
        console.log(`DEBUG [ApiService getDeliveryNotes] value: ${orderNumer}`);
        try {
            // real call
            let responseFull = (await this.callApi('getDeliveryNotes', [orderNumer]));
            console.log('getDeliveryNotes api response:');
            console.log(responseFull);
            let response = responseFull.data;
            callback(response.map(p => {
                // console.log(p);
                return {
                    deliveryNoteNumber: p
                };
            }))
        }catch (error) {
            console.log(JSON.stringify(error));
            throw new Error (error.message);
        }
    }    

    async getDocumentProfiles(orderNumber, deliveryNoteNumber, orderPosition, serialNumber, callback){
        console.log(`DEBUG [ApiService getDocumentProfiles] orderNumber: ${orderNumber} orderPosition:${orderPosition} serialNumber:${serialNumber}`);
        try {
            let response = (await this.callApi('documentProfiles',[orderNumber, deliveryNoteNumber, orderPosition, serialNumber ])).data;
            console.log(response);
            callback(response.map((p,idx) => {
                // console.log(p);
                return {
                    profileNumber: p,
                    orderPosition: orderPosition,
                    serialNumber: serialNumber,
                    index: idx,
                    name: ''
                };
            }))
        }catch(error) {
            console.log(JSON.stringify(error));
            throw new Error (error.message);
        }

    }    


    async getDocumentProfilesAll(orderNumber, deliveryNoteNumber, orderPosition, callback){
        console.log(`DEBUG [ApiService getDocumentProfilesAll] orderNumber: ${orderNumber} orderPosition:${orderPosition}`);
        try {
            let response = (await this.callApi('documentProfilesAll',[orderNumber, deliveryNoteNumber, orderPosition ])).data;
            console.log(`getDocumentProfilesAll: ${JSON.stringify(response)}`);
            callback(response.map((p,idx) => {
                // console.log(p);
                return {
                    profileNumber: p,
                    orderPosition: orderPosition,
                    index: idx,
                    name: ''
                };
            }))
        }catch(error) {
            console.log(JSON.stringify(error));
            throw new Error (error.message);
        }

    }        

    async changeDNN(orderNumber,deliveryNoteNumber,newDeliveryNoteNumber,callback){
        console.log(`DEBUG [ApiService changeDNN] 
            orderNumber: ${orderNumber} 
            deliveryNoteNumber:${deliveryNoteNumber} 
            newDeliveryNoteNumber:${newDeliveryNoteNumber}`);
            
        try {
            let response = (await this.callApi(
                'changeDNN',
                [orderNumber, deliveryNoteNumber],
                'PATCH',
                {"deliveryNoteNumber" : newDeliveryNoteNumber}
            )).data;
            // console.log(response);
            callback(response);
        }catch(error) {
            console.log(JSON.stringify(error));
            throw new Error (error.message);
        }
    }

    async getUploadedDocuments(orderNumber, deliveryNoteNumber) {

    }
}

export default ApiService
